import {
  // Gros oeuvre
  Construction, Blocks, Home, Building2, Factory, ArrowUpFromLine, Mountain, HardHat,
  // Second oeuvre
  Zap, Wrench, Flame, Snowflake, Wind, ShowerHead, CookingPot, DoorOpen, DoorClosed, Layers, Shield, Package,
  // Finitions
  Paintbrush, Brush, Grid3X3, TreeDeciduous, Sparkles, Square, Image, Lightbulb, Droplets, Sofa,
  // Exterieur
  Waves, TreePine, Leaf, Fence, Car, Hexagon, Route, Umbrella, Droplet, Flashlight,
  // Toiture
  Warehouse, CloudRain, Sun, LayoutGrid,
  // Specialise
  Lock, ArrowUpDown, Volume2, Accessibility, ShieldCheck, Wifi,
  LucideIcon
} from 'lucide-react';

export interface Pictogramme {
  id: string;           // Nom de l'icône Lucide
  label: string;        // Nom affiché
  icon: LucideIcon;     // Composant icône
  categorie: string;    // Catégorie pour le regroupement
}

export interface CategoriesPictogrammes {
  id: string;
  label: string;
  pictogrammes: Pictogramme[];
}

export const CATEGORIES_PICTOGRAMMES: CategoriesPictogrammes[] = [
  {
    id: 'gros_oeuvre',
    label: 'Gros oeuvre',
    pictogrammes: [
      { id: 'Construction', label: 'Construction neuve', icon: Construction, categorie: 'gros_oeuvre' },
      { id: 'Blocks', label: 'Maçonnerie', icon: Blocks, categorie: 'gros_oeuvre' },
      { id: 'Home', label: 'Rénovation complète', icon: Home, categorie: 'gros_oeuvre' },
      { id: 'Building2', label: 'Immeuble / Bâtiment', icon: Building2, categorie: 'gros_oeuvre' },
      { id: 'Factory', label: 'Local commercial', icon: Factory, categorie: 'gros_oeuvre' },
      { id: 'ArrowUpFromLine', label: 'Extension / Surélévation', icon: ArrowUpFromLine, categorie: 'gros_oeuvre' },
      { id: 'Mountain', label: 'Terrassement / Fondations', icon: Mountain, categorie: 'gros_oeuvre' },
      { id: 'HardHat', label: 'Démolition', icon: HardHat, categorie: 'gros_oeuvre' },
    ],
  },
  {
    id: 'second_oeuvre',
    label: 'Second oeuvre',
    pictogrammes: [
      { id: 'Zap', label: 'Électricité', icon: Zap, categorie: 'second_oeuvre' },
      { id: 'Wrench', label: 'Plomberie', icon: Wrench, categorie: 'second_oeuvre' },
      { id: 'Flame', label: 'Chauffage', icon: Flame, categorie: 'second_oeuvre' },
      { id: 'Snowflake', label: 'Climatisation', icon: Snowflake, categorie: 'second_oeuvre' },
      { id: 'Wind', label: 'Ventilation / VMC', icon: Wind, categorie: 'second_oeuvre' },
      { id: 'ShowerHead', label: 'Salle de bain', icon: ShowerHead, categorie: 'second_oeuvre' },
      { id: 'CookingPot', label: 'Cuisine', icon: CookingPot, categorie: 'second_oeuvre' },
      { id: 'DoorOpen', label: 'Menuiserie intérieure', icon: DoorOpen, categorie: 'second_oeuvre' },
      { id: 'DoorClosed', label: 'Portes / Fenêtres', icon: DoorClosed, categorie: 'second_oeuvre' },
      { id: 'Layers', label: 'Isolation', icon: Layers, categorie: 'second_oeuvre' },
      { id: 'Shield', label: 'Étanchéité', icon: Shield, categorie: 'second_oeuvre' },
      { id: 'Package', label: 'Placo / Cloisons', icon: Package, categorie: 'second_oeuvre' },
    ],
  },
  {
    id: 'finitions',
    label: 'Finitions',
    pictogrammes: [
      { id: 'Paintbrush', label: 'Peinture intérieure', icon: Paintbrush, categorie: 'finitions' },
      { id: 'Brush', label: 'Façade / Ravalement', icon: Brush, categorie: 'finitions' },
      { id: 'Grid3X3', label: 'Carrelage', icon: Grid3X3, categorie: 'finitions' },
      { id: 'TreeDeciduous', label: 'Parquet / Bois', icon: TreeDeciduous, categorie: 'finitions' },
      { id: 'Sparkles', label: 'Revêtement de sol', icon: Sparkles, categorie: 'finitions' },
      { id: 'Square', label: 'Vitrerie / Miroiterie', icon: Square, categorie: 'finitions' },
      { id: 'Image', label: 'Papier peint / Décoration', icon: Image, categorie: 'finitions' },
      { id: 'Lightbulb', label: 'Éclairage', icon: Lightbulb, categorie: 'finitions' },
      { id: 'Droplets', label: 'Robinetterie / Sanitaires', icon: Droplets, categorie: 'finitions' },
      { id: 'Sofa', label: 'Aménagement intérieur', icon: Sofa, categorie: 'finitions' },
    ],
  },
  {
    id: 'exterieur',
    label: 'Extérieur',
    pictogrammes: [
      { id: 'Waves', label: 'Piscine', icon: Waves, categorie: 'exterieur' },
      { id: 'TreePine', label: 'Aménagement paysager', icon: TreePine, categorie: 'exterieur' },
      { id: 'Leaf', label: 'Jardin / Espaces verts', icon: Leaf, categorie: 'exterieur' },
      { id: 'Fence', label: 'Clôture / Portail', icon: Fence, categorie: 'exterieur' },
      { id: 'Car', label: 'Garage / Abri', icon: Car, categorie: 'exterieur' },
      { id: 'Hexagon', label: 'Terrasse / Dallage', icon: Hexagon, categorie: 'exterieur' },
      { id: 'Route', label: 'Allée / Chemin', icon: Route, categorie: 'exterieur' },
      { id: 'Umbrella', label: 'Pergola / Store', icon: Umbrella, categorie: 'exterieur' },
      { id: 'Droplet', label: 'Arrosage / Drainage', icon: Droplet, categorie: 'exterieur' },
      { id: 'Flashlight', label: 'Éclairage extérieur', icon: Flashlight, categorie: 'exterieur' },
    ],
  },
  {
    id: 'toiture',
    label: 'Toiture',
    pictogrammes: [
      { id: 'Warehouse', label: 'Toiture / Couverture', icon: Warehouse, categorie: 'toiture' },
      { id: 'CloudRain', label: 'Gouttières / Zinguerie', icon: CloudRain, categorie: 'toiture' },
      { id: 'Sun', label: 'Panneaux solaires', icon: Sun, categorie: 'toiture' },
      { id: 'LayoutGrid', label: 'Velux / Fenêtre de toit', icon: LayoutGrid, categorie: 'toiture' },
    ],
  },
  {
    id: 'specialise',
    label: 'Spécialisé',
    pictogrammes: [
      { id: 'Lock', label: 'Serrurerie', icon: Lock, categorie: 'specialise' },
      { id: 'ArrowUpDown', label: 'Ascenseur / Monte-charge', icon: ArrowUpDown, categorie: 'specialise' },
      { id: 'Volume2', label: 'Acoustique', icon: Volume2, categorie: 'specialise' },
      { id: 'Accessibility', label: 'Accessibilité PMR', icon: Accessibility, categorie: 'specialise' },
      { id: 'ShieldCheck', label: 'Sécurité / Alarme', icon: ShieldCheck, categorie: 'specialise' },
      { id: 'Wifi', label: 'Domotique / Réseau', icon: Wifi, categorie: 'specialise' },
    ],
  },
];

// Helper pour récupérer tous les pictogrammes à plat
export const TOUS_PICTOGRAMMES: Pictogramme[] = CATEGORIES_PICTOGRAMMES.flatMap(cat => cat.pictogrammes);

// Helper pour trouver un pictogramme par son id
export function getPictogrammeById(id: string): Pictogramme | undefined {
  return TOUS_PICTOGRAMMES.find(p => p.id === id);
}
